import L from "@/plugins/leaflet";
import { ButtonControl } from "./ButtonControl";

export const ButtonGroupControl = L.Control.extend({
  initialize: function(buttons, options) {
    L.setOptions(this, options);
    this.buttons = buttons || [];
  },

  onAdd(map) {
    this._map = map;
    this._container = document.createElement("div");
    this._container.className = "leaflet-bar leaflet-control";

    this.attachCurrentButtons();

    return this._container;
  },

  /**
   *
   * @param {ButtonControl} button
   */
  addButton(button) {
    this.buttons.push(button);

    this.attachButton(button);
  },

  /**
   * @private
   */
  attachCurrentButtons() {
    this.buttons.forEach(button => this.attachButton(button));
  },

  /**
   *
   * @param {ButtonControl} button
   */
  attachButton(button) {
    if (!this._container) return;

    this._container.append(button.onAdd(this._map));
  }
});

/**
 *
 * @param {Object[]} buttons
 * @param {String} buttons.title
 * @param {String} buttons.icon Material Icon Name. https://material.io/resources/icons
 * @param {String} [buttons.className]
 * @param {() => void} buttons.onClick
 */
ButtonGroupControl.create = function(buttons, options) {
  return new ButtonGroupControl(
    buttons.map(
      b => new ButtonControl(b.title, b.icon, b.className, b.onClick)
    ),
    options
  );
};
